export { default } from './EventDetailsContent';
